<template>
    <main>
        <vx-card>
            <h1 class="mb-6">FAQ</h1>
            <vs-collapse>
                <vs-collapse-item
                    v-for="(item, i) in contents"
                    :key="i"
                >
                    <div slot="header">{{ item.title }}</div>
                    <div v-html="item.content"></div>
                </vs-collapse-item>
            </vs-collapse>
        </vx-card>
    </main>
</template>
<script>

export default {
    data: () => ({
        contents: [
            {
                title: 'Apa itu ZX?',
                content: '<p>ZX merupakan sebuah platform untuk transaksi Zakat, Infak dengan mudah.</p>'
            }
        ]
    })
}
</script>
